<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Cupons
            <router-link to="/app/sales/voucher/">
              <l-button wide type="primary" round style="float: right; margin-right: 15px; margin-top: 5px">
                <span class="btn-label">
                  <i class="fa fa-plus"></i>
                </span>
                Criar
              </l-button>
            </router-link>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
              <!-- Tipo -->
            <div class="col-sm-12">
              <label class="col-sm-6">Válido em:</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="validoEm"
              >
                <el-option
                  v-for="option in valido"
                  class="select-danger"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
                <!-- Se for produto -->
            <div class="col-sm-12" v-if="validoEm === 'only_product'">
              <label class="col-sm-6">Produtos</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="produto"
              >
                <el-option
                  v-for="option in productsName"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
                <!-- Se for categoria -->
            <div class="col-sm-12" v-if="validoEm === 'only_category'">
              <label class="col-sm-6">Categoria</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="category"
              >
                <el-option
                  v-for="option in categories"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
              <!-- (des)Ativado -->
            <div class="col-sm-12">
              <label class="col-sm-6">Status</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="statusCupom"
              >
                <el-option
                  v-for="option in status"
                  class="select-danger"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
            <!-- <div class="col-sm-11" style="margin-top: 10px">
              <label class="col-sm-6">Periodo</label>
              <el-date-picker
                style="margin-left: 15px"
                v-model="date_init"
                type="daterange"
                format="dd/MM/yyyy"
                align="right"
                unlink-panels
                range-separator="a"
                start-placeholder="Data de início"
                end-placeholder="Data final">
              </el-date-picker>
            </div> -->
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
          <el-table-column type="expand">
            <template slot-scope="props">
              <p> <b>Descrição:</b>  {{ props.row.description }}  </p>
              <p> <b>Válido para: </b> <span v-if="props.row.limit === 'Produto'">{{ props.row.product_name }}</span> 
                                       <span v-if="props.row.limit === 'Categoria'">{{ props.row.category_name }}</span>
                                       <span v-if="props.row.limit === 'Toda empresa'">{{ props.row.limit }}</span>

              <!-- <el-button icon="nc-icon nc-zoom-split"
                @click="filtro = true"
                class="pesquisa" 
                circle
                style="font-size: 0.9em; float: right; margin-right: 15px"></el-button> -->
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                    v-if="props.row.usage == 0"
                    class="btn btn-danger btn-link btn-xs"
                    style="font-size: 0.9em; float: right; margin-right: -25px"
                    @click="deleteVoucher(props.row)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </a>
                </el-tooltip>
              </p>
            </template>
          </el-table-column>
            <el-table-column label="Código" property="code" min-width="70" />
            <el-table-column label="Filial" property="company_name" min-width="70" v-if="showMatriz" />
            <el-table-column label="Valor" property="tipo" min-width="55"  />
            <el-table-column label="Quantidade" property="usage_quota" min-width="60" />
            <el-table-column label="Usos" property="usage" min-width="35"/>
            <el-table-column label="Válido em:" property="limit" 
                            :filters="[{ text: 'Produto', value: 'Produto' },
                                      { text: 'Categoria', value: 'Categoria' },
                                      { text: 'Toda empresa', value: 'Toda empresa' }]"
                            :filter-method="filterTag2" />
            <el-table-column label="Data início" property="data_inicio" sortable="custom" />
            <el-table-column label="Data fim" property="data_fim" sortable="custom" />
            <!-- <el-table-column label="Ações" width="65"> -->

              <el-table-column
                prop="ativo"
                label="Status"
                width="130"
                :filters="[{ text: 'Ativado', value: 'Ativado' },
                           { text: 'Desativado', value: 'Desativado' },
                           { text: 'Vencido', value: 'Vencido' },
                           { text: 'Finalizado', value: 'Finalizado' }]"
                :filter-method="filterTag"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.ativo !== 'Finalizado' && scope.row.ativo !== 'Vencido'"
                    :type="scope.row.ativo === 'Desativado' ? 'danger' : 'success'"
                    disable-transitions><a @click="changeStatus(scope.row)">{{scope.row.ativo}}</a></el-tag> 
                  <!-- <el-tag
                    v-if="scope.row.usage === scope.row.usage_quota  && !scope.row.vencido"
                    disable-transitions><a >Finalizado</a></el-tag>  -->
                  <el-tag
                    v-else
                    disable-transitions><a >{{scope.row.ativo}}</a></el-tag> 
                </template>
              </el-table-column>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Tooltip,
  Tag,
  Loading
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag
  },
  data () {
    return {
      filtro: false,
      produto: [],
      tipo: [],
      prateleira: [],
      vendMachine: [],
      date_init: [],
      categories: [],
      category: '',
      vouchers: [],
      valido: [{label: 'Categoria', value: 'only_category'},
               {label: 'Produto', value: 'only_product'}, 
               {label: 'Toda empresa', value: 'total'}, ],
      validoEm: '',
      status: [{label: 'Ativado', value: true},
               {label: 'Desativado', value: false} ],
      statusCupom: '',
      products: [],
      machines: [],
      showTable: true,
      vouchersAPI: [],
      totalResults: 30,
      pesquisa: '',
      page: 1,
      pageSize: 10,
      order: false,
      loading: true,
      btnLoading: false,
      sord: '',
    }
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted () {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany()
  },
  computed: {
    tableData() {
      let vouchers = this.vouchers
      let dateConverted = vouchers.map(v => {
        let ativo, tipo, data_inicio, data_fim, limit, vencido
        if (v.start_date) {
          data_inicio = new Date(v.start_date).toLocaleDateString('pt-br')
        }
        if (v.end_date) {
          data_fim = new Date(v.end_date).toLocaleDateString('pt-br')
        }
        let parts = data_fim.split('/') 
        let fim_data
        let today = new Date()  
        fim_data = new Date(parts[2], parts[1] - 1, parts[0]) 
        vencido = fim_data <= today ? true : false

        if (v.is_active) {
          ativo = 'Ativado'
        }
        if (!v.is_active) {
          ativo = 'Desativado'
        }
        if (v.usage === v.usage_quota) {
          ativo = 'Finalizado'
        }
        if (vencido && v.usage !== v.usage_quota) {
          ativo = 'Vencido'
        }
        if (v.type === 'only_product') {
           limit = 'Produto'
        }
        if (v.type === 'only_category') {
           limit = 'Categoria'
        }
        if (v.type === 'total') {
           limit = 'Toda empresa'
        }
        if (v.value_type === "amount") {
          tipo = 'R$' + v.value
        }
        if (v.value_type === 'percentage') {
          tipo = v.value + '%'
        }
        return { ...v, ativo,  tipo, data_inicio, data_fim, limit, vencido };
      });
      console.log('conver', dateConverted)
      return dateConverted
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    productsName() {
      return this.$store.state.products.products;
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === "data_inicio") {
        x.prop = 'start_date'
      }
      if (x.prop === 'data_fim') {
        x.prop = 'end_date'
      }
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filtragem () {
      this.vouchers = this.vouchersAPI
      var date = []
      this.pesquisa = ''

      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + '&company=' + ciaID
      }

      if (this.validoEm) {
        this.pesquisa = this.pesquisa + '&type=' + this.validoEm
      }
      if (this.category) {
        this.pesquisa = this.pesquisa + '&category=' + this.category
      }
      if (this.produto) {
        this.pesquisa = this.pesquisa + '&product=' + this.produto
      }
      if (this.statusCupom) {
        this.pesquisa = this.pesquisa + '&is_active=true'
      }
      if (!this.statusCupom) {
        this.pesquisa = this.pesquisa + '&is_active=false'
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisa = this.pesquisa + '&created__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()
      this.filtro = false;
    },
    clearFiltro() {
      this.produto = "";
      this.statusCupom = ''
      this.category = ''
      this.validoEm = ''
      this.tipo = "";
      this.prateleira = "";
      this.vendMachine = "";
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.date_init = []
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filterTag(value, row) {
      return row.ativo === value;
    },
    filterTag2(value, row) {
      return row.limit === value;
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    deleteVoucher (data) {
      console.log('dele', data)
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse Cupom.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("vouchers/delete", { id: data.id }).then(() =>{
            swal.fire({
              title: "Pronto!",
              text: `Cupom excluído.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(result =>{
              const ciaID = localStorage.getItem('imachCiaID')
              if (ciaID) {
                this.getData(ciaID)
              } else {
                this.getData()
              }
            })
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Cupom não excluído.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    changeStatus(data) {
      console.log('click', data)
      if (data.ativo === 'Ativado') {
        swal.fire({
          title: "Trocar Status",
          text: 'Deseja trocar o status do Cupom de Ativado para Desativado?',
          icon: "question",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Desativar!",
          cancelButtonText: "Cancelar",
          cancelButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        }).then(result =>{
          if (result.value) {
            var payload = {
              id: data.id,
              is_active : false
            }
            this.$store.dispatch('vouchers/update',{item: payload}).then (resp =>{
               swal.fire({
                title: "Pronto!",
                text: `Cupom Desativado`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            })
            setTimeout(() => {
              const ciaID = localStorage.getItem('imachCiaID')
              if (ciaID) {
                this.getData(ciaID)
              } else {
                this.getData()
              }
            }, 350);
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Não foi desativado`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
          }
        })  
      } else {
         swal.fire({
          title: "Trocar Status",
          text: 'Deseja trocar o status do Cupom de Desativado para Ativado?',
          icon: "question",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Ativar!",
          cancelButtonText: "Cancelar",
          cancelButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        }).then(result =>{
          if (result.value) {
            var payload = {
              id: data.id,
              is_active : true
            }
            this.$store.dispatch('vouchers/update',{item: payload}).then (resp =>{
               swal.fire({
                title: "Pronto!",
                text: `Cupom Ativado`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            })
            setTimeout(() => {
              const ciaID = localStorage.getItem('imachCiaID')
              if (ciaID) {
                this.getData(ciaID)
              } else {
                this.getData()
              }
            }, 350);
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Não foi ativado`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
          }
        })  
      }
    },
    getData (id) {
      this.loading = true
      if (id) { 
        id = id
      } else {
        id = ''
      }
          this.$store.dispatch("vouchers/listSort", {sort: '?page_size=' + this.pageSize
            + '&page=' + this.page + '&company=' + id +
            '&ordering=' + this.sord + this.pesquisa}).then(resp => {
            this.totalResults = this.$store.state.vouchers.page.count
            this.vouchers = resp
            this.vouchersAPI = resp
            this.loading = false
            this.tableData
          }).catch(err => console.log(err));
        this.$store.dispatch("categories/listSort",{sort: '?company=' + id}).then(resp =>{
          this.categories = resp
        }).catch(err => console.log(err));
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
